import React, { memo } from 'react'
import { ICarrierReference } from 'types/carrier'
import { displayKeys, CARRIER_REFERENCE_KEYS } from 'apps/carrier/constants/carrierReferences'
import { ConnectedPhoneNumber } from 'apps/marketplace/components/ConnectedPhoneNumber'

interface IReferenceProps {
  reference: ICarrierReference
  index: number
}

const Reference = memo<IReferenceProps>(({ index, reference }) => {
  const { id: userId, parentUserId } = reference.reviewedBy || {}

  const infoElements = displayKeys
    .filter((key: CARRIER_REFERENCE_KEYS) => reference[key])
    .map((key: CARRIER_REFERENCE_KEYS) => {
      if (key === CARRIER_REFERENCE_KEYS.PHONE) {
        return <ConnectedPhoneNumber phoneNumber={reference[key]} key={reference.id + key} />
      }
      return <span key={reference.id + key}>{reference[key]}</span>
    })
    .reduce((acc: JSX.Element[], val: JSX.Element, idx: number) => {
      const key = `${reference.id}-${idx}`
      if (acc.length === 0) return [val]
      return [...acc, <span key={key}>&nbsp;&middot;&nbsp;</span>, val]
    }, [])

  return (
    <div className='pv4' data-test='profile-reference-entry'>
      <div>Reference #{index + 1}</div>
      {infoElements}
      {reference.reviewedBy && userId && (
        <div className='text-secondary'>
          Reviewed by&nbsp;
          <a
            href={`${__ROOT__}/users/${parentUserId}`}
            data-test='id-reviewer'
            target='_blank'
            rel='noopener noreferrer'>
            {reference.reviewedBy.firstName} {reference.reviewedBy.lastName}
          </a>
        </div>
      )}
      {!reference.reviewedBy && <div className='text-secondary'>Not reviewed yet.</div>}
    </div>
  )
})

export default Reference
